import { Routes } from '@angular/router';
import { LoginSuccessGuard } from '@uoa/auth';
import { ErrorPage } from '@uoa/error-pages';

export const ApplicationRoutes: Routes = [
  {
    path: '',
    canActivate: [LoginSuccessGuard],
    loadComponent: () => import('./pages/home/home.page').then((m) => m.HomePage),
  },
  {
    path: 'home',
    redirectTo: '',
    canActivate: [LoginSuccessGuard],
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'ncea',
    loadComponent: () => import('./pages/ncea/ncea.page').then((m) => m.NCEAPage),
  },
  {
    path: 'cie',
    loadComponent: () => import('./pages/cie/cie.page').then((m) => m.CiePage),
  },
  {
    path: 'error/:errorCode',
    component: ErrorPage,
  },
  {
    path: '**',
    redirectTo: '',
  }
];
